import request from '../utils/request.js';
let apiConfig = null;
try {
  apiConfig = require('../../src/config/api').default;
} catch (e) {
  // 文件不存在时忽略错误
}
const material = process.env.VUE_APP_MATERIAL;
const baseApi = process.env.VUE_APP_TASK_BASE;
const isLocal = false;
const SNAPCHAT = apiConfig?.VUE_APP_SNAPCHAT_AUTOGOODS || process.env.VUE_APP_SNAPCHAT_AUTOGOODS;
const GIAMBASE = apiConfig?.VUE_APP_GIAM_BASE || process.env.VUE_APP_GIAM_BASE;
// const isLocal = process.env.VUE_APP_API_ENV === 'development' || process.env.VUE_APP_API_ENV === 'develop';
// const isLocal =
//   (material !== 'https://manage-pre.giikin.com/middle/material' && material !== '/material') ||
//   process.env.VUE_APP_API_ENV === 'development';
//  && material !== '/material'
function getUrl(url, prefix = 'work') {
  console.log(isLocal, material, process.env, 'isLocal, prefix, url');

  return isLocal ? `/${prefix}/${url}?_token=60afd310ed1ddd716b8aa6d15e3f2ac8` : `/open/${url}`;
}
// 广告素材上传入库
export function postSaveAdFile(data) {
  return request({
    baseURL: material,
    // url: '/work/saveAdFile',
    withCredentials: true,
    url: getUrl('saveAdFile'),
    method: 'post',
    data: data,
    notThirdLoginUserId: true,
    notNeedToken: true,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

//生成阿里云sts token
export function getOssAccessToken() {
  return request({
    baseURL: material,
    withCredentials: true,
    // url: '/cross/makeOssAccessToken?_token=88adba1062dc8ab528ba92c06dc5c23b',
    url: getUrl('makeOssAccessToken', 'cross'),
    method: 'post',
    notThirdLoginUserId: true,
    notNeedToken: true,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
//检测广告素材是否已存在
export function getAdFileExist(data) {
  return request({
    baseURL: material,
    withCredentials: true,
    // url: '/work/adFilesExist',
    url: getUrl('adFilesExist'),
    method: 'post',
    data: data,
    notThirdLoginUserId: true,
    notNeedToken: true,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
//用户个人广告素材列表
export function userFileRelateList(data) {
  return request({
    baseURL: material,
    withCredentials: true,
    // url: '/work/userFileRelateList?_token=88adba1062dc8ab528ba92c06dc5c23b',
    url: getUrl('userFileRelateList'),
    method: 'post',
    data: data,
    notThirdLoginUserId: true,
    notNeedToken: true,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 素材投放指标批量查询（开放平台 materialListV2）
// 用个人素材的 md5_code 作为 media_hash（多个用逗号分隔）查询投放表现数据
// ⚠️ url 完整路径与鉴权 header(gk-service-user) 以联调结果为准
export function materialListV2(data) {
  return request({
    baseURL: material,
    url: '/adMaterial/materialListV2',
    method: 'post',
    data: data,
    withCredentials: true,
    notThirdLoginUserId: true,
    notNeedToken: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
// 保存用户素材日志
export function saveOptLog(data) {
  return request({
    baseURL: baseApi,
    url: '/api/media/saveOptLog',
    method: 'post',
    data,
    timeout: 0,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
/** 保存用户素材日志--snapchat */
export function saveOptLogSnap(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/ads/saveOptLog',
    method: 'post',
    data,
    timeout: 0,
  });
}

// 广告素材库过滤参数
export function getLocalFilterParamApi(params) {
  return request({
    baseURL: GIAMBASE,
    url: `/common/function/media/localFilterParam`,
    method: 'get',
    params,
  });
}

// 广告素材
export function ttmediaLocalAdLibApi(data) {
  return request({
    baseURL: GIAMBASE,
    url: '/common/function/media/localAdLib',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 广告个人素材打标（AI标记）
export function postUpdateFileAiTag(data) {
  return request({
    baseURL: material,
    url: '/work/updateFileAiTag',
    method: 'post',
    data,
    withCredentials: true,
    notThirdLoginUserId: true,
    notNeedToken: true,
  });
}

// 查询文件 AI 标记（批量，fileIds 多个用逗号隔开）
export function postGetFileAiTag(data) {
  return request({
    baseURL: material,
    url: '/work/getFileAiTag',
    method: 'post',
    data,
    withCredentials: true,
    notThirdLoginUserId: true,
    notNeedToken: true,
  });
}

// 提交素材风险检测
export function submitVideoRisk(data) {
  return request({
    baseURL: GIAMBASE,
    url: '/video/risk/submit',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 批量提交素材风险检测
export function batchSubmitVideoRisk(data) {
  return request({
    baseURL: GIAMBASE,
    url: '/video/risk/batchSubmit',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 获取素材审核状态列表
export function listAuditStatus(data) {
  return request({
    baseURL: GIAMBASE,
    url: '/video/risk/listAuditStatus',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
